import ListingPage from "../components/ListingPage";
import { DISEASE_CONTENT } from "../data/diseaseContent";

export default function DiseasesIndex() {
  const items = Object.entries(DISEASE_CONTENT).map(([slug, d]) => ({
    slug,
    shortTitle: d.shortTitle,
    blurb: d.subtitle,
  }));
  return (
    <ListingPage
      kind="Condition"
      slug="diseases"
      eyebrow="Conditions Treated · Varanasi"
      title="Gastro & Liver conditions, in depth."
      subtitle="Each condition gets a focused, doctor-written page — symptoms, causes, diagnosis, treatment and when to see a specialist. Built for clarity, not page-views."
      items={items}
      seoTitle="Gastro & Liver Conditions Treated in Varanasi | Dr. Indresh Dixit"
      seoDescription="Long-form, doctor-authored pages on fatty liver, hepatitis B/C, cirrhosis, GERD, gastritis, pancreatitis, UC, Crohn's and peptic ulcer — treatment in Varanasi by Dr. Indresh Dixit."
    />
  );
}
